import React from "react";
import { Modal } from "antd";
import AlertBox from "../shared/AlertBox";

export const ConfirmExit = ({
    visible,
    onConfirm,
    onCancel
}) => {
    return (
        <AlertBox id="confirmation-alert"
                            open={visible}
                            type="Yes/No"
                            title={"Unsaved Changes"}
                            message={"You have unsaved changes. If you leave this screen, your changes will be lost."}
                            yesClick={onConfirm}
                            noClick={onCancel} />
    );
};